<template>
	<v-container fluid pa-0 mx-2 style="width: auto;"
		:style="menuOpen ? 'z-index: 999;':''">
		<v-menu
			v-model="menuOpen"
			bottom
			offset-y
			left
			min-width="500"
			max-width="500"
			content-class="container-notification-menu-header"
			:close-on-content-click="false"
			@input="changeMenu"
		>
			<template v-slot:activator="{ on, attrs }">
				<v-badge
					:color="$store.state.notifications.badgeColorChat"
					:content="$store.state.notifications.badgeTextChat"
					:value="showBadge"
					bordered
					overlap
				>
					<v-btn
						fab
						dark
						class="button-activator-notifications"
						:small="size === 'small'"
						:x-small="size === 'x-small'"
						:loading="$store.state.notifications.loadingChatNotifications"
						color="#FF120B"
						v-bind="attrs"
						v-on="on"
						@click="clearTray"
					>
						<v-icon small dark>mdi-chat-outline</v-icon>
					</v-btn>
				</v-badge>
			</template>
			<div class="d-flex flex-row align-center justify-space-between">
				<div class="d-flex flex-row px-4" style="border-left: 2px solid #524D4D;">
					<v-icon dark color="#524D4D" class="mr-5">mdi-chat-outline</v-icon>
					<p class="mb-0 font-weight-bold" style="color: #524D4D">Notificaciones Chat</p>
				</div>
				<div>
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn icon color="grey" class="mr-3"
										v-bind="attrs"
										v-on="on"
										@click="markAllNotificationsAsRead">
								<v-icon>mdi-email-open-multiple-outline</v-icon>
							</v-btn>
						</template>
						<span>Marcar todo como visto</span>
					</v-tooltip>
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn icon color="grey" class="mr-3"
										v-bind="attrs"
										v-on="on"
										@click="reloadNotifications()">
								<v-icon>mdi-cached</v-icon>
							</v-btn>
						</template>
						<span>Recargar notifications</span>
					</v-tooltip>
				</div>
			</div>
			<v-divider class="mx-2"></v-divider>
			<div v-if="$store.state.notifications.chatNotifications.length > 0">
				<v-list style="max-height: 75vh;overflow: scroll;">
					<v-list-item
						v-for="(item, i) in $store.state.notifications.chatNotifications"
						:key="i"
						class="px-0 py-0"
						@click="viewItem(item, i)"
					>
						<div style="width: 100%">
						<div class="d-flex flex-row px-4 pt-2 justify-space-between" style="gap: 12px;">
							<div class="d-flex flex-row" style="flex: 1; min-width: 0;">
								<img v-if="getNotificationImage(item)"
									:src="getNotificationImage(item)" class="notification-img"/>
								<v-icon v-else class="notification-img icon" color="#524D4D" >mdi-account</v-icon>
								<div class="px-4 caption" style="flex: 1; min-width: 0;">
									<small class="mb-0" style="color: #707070;" v-html="getNotificationTitleInfo(item)"></small>
									<p class="mb-0 caption font-weight-bold" style="color: #707070; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 0;">{{ item.title }}</p>
									<div class="mb-0 caption notification-description" style="color: #707070;" v-html="item.description">{{ item.description }}</div>
								</div>
							</div>
							<div class="d-flex flex-column align-center" style="flex-shrink: 0;">
									<v-tooltip bottom>
										<template v-slot:activator="{ on, attrs }">
											<v-btn icon
												@click.stop="markNotificationAsRead(item.id, i)"
												v-bind="attrs"
												v-on="on">
												<v-icon
													small
													:color="item.readed || loadingIndexes.includes(i) ? 'grey lighten-2':'#FF120B'"
													>mdi-circle</v-icon>
											</v-btn>
										</template>
										<span>Marcar como vista</span>
									</v-tooltip>
									<div style="min-width: 50px;">
										<p class="text-center mb-0" style="color: #707070;font-size: 10px;">{{ item.created_at | toDate }}</p>
										<p class="text-center mb-0" style="color: #707070;font-size: 10px;">{{ item.created_at | toHour }}</p>
									</div>
								</div>
							</div>
							<v-divider class="mt-2 mx-2"></v-divider>
						</div>
					</v-list-item>
					<div class="mt-3 mx-4">
						<v-btn
							depressed
							color="#524D4D"
							:dark="$store.state.notifications.chatNotifications.length >= 10"
							block
							small
							:loading="$store.state.notifications.loadingChatNotifications"
							:disabled="$store.state.notifications.chatNotifications.length < 10"
							@click="reloadNotifications(10)"
						>
							<v-icon small>mdi-email-outline</v-icon>
							<p class="mb-0 ml-2 caption">Ver antiguas</p>
						</v-btn>
					</div>
				</v-list>
			</div>
			<div v-else class="d-flex flex-column align-center justify-center">
				<v-icon class="mt-3 mb-2" large>mdi-check-circle-outline</v-icon>
				<p class="body-2">No hay notificaciones nuevas</p>
			</div>
		</v-menu>
	</v-container>
</template>

<script>
import {markAsReaded} from '@/helpers/api/notifications'

export default {
	name: 'NotificationHeader',
	props: {
		size: {
			type: String,
			default: 'small'
		},
		clearTray: {
			type: Function,
			required: true
		}
	},
	components: {
	},
  computed: {
		showBadge(){
			return this.$store.state.notifications.hasChatNotifications
			// return this.$store.state.notifications.badgeTextChat !== '0' && this.$store.state.notifications.badgeTextChat !== '--' && this.$store.state.notifications.hasChatNotifications
		},
    loadingNotifications() {
      return this.$store.state.notifications.loadingChatNotifications
    },
		userInfo() {
			return this.$store.state.user.userInfo
		},
		selectedCompany(){
			return this.$store.state.companies.selectedCompany
		},
		isCompanyClient(){
			if(this.selectedCompany && this.userInfo){
				const company = this.userInfo.companies.find((company) => {
					return this.$store.state.companies.selectedCompany.id == company.id
				})
				return company?.role_id == 4
			}
			return false
		},
  },
  watch: {
    loadingNotifications(newData) {
      if(newData){
				this.reloading = true
      }
			else if(this.reloading){
				this.reloading = false
				this.loadingIndexes = []
				this.loadingTaskIndexes = []
				this.loadingRdiIndexes = []
			}
    }
  },
	data: () => ({
		reloading: false,
		loadingIndexes: [],
		loadingTaskIndexes: [],
		loadingRdiIndexes: [],
		menuOpen: false,
		maxNotifications: 10
	}),
	mounted(){
		this.reloadNotifications()
	},
	methods: {
		getNotificationTitleInfo(item) {
			let name = ''
			let district = ''
			let client = ''
			if(item.itemable?.morphable?.associations){
				name = '[LP' + item.itemable?.morphable?.number + '] ' + (item.itemable?.name ?? '');
				district = this.getProjectLineDistrict(item.itemable?.morphable) ?? '--';
				if(district !== '--' && district.length > 30) {
					district = district.substring(0, 30) + '...';
				}
				client = this.getProjectLineClient(item.itemable?.morphable) ?? '';
				return `Proyecto: <b>${name} | ${district} | ${client}</b>`;
			}
			const user_name = item.itemable?.name || item.itemable?.morphable?.profile?.name + ' ' + item.itemable?.morphable?.profile?.lastname  + ' ' + item.itemable?.morphable?.profile?.second_lastname || 'Cliente';
			return `Cliente: <b>${user_name}</b>`;
		},
		getProjectLineDistrict(projectLine){
			const priority = [
				'App\\Models\\Project',
				'App\\Models\\PreProject', 
				'App\\Models\\BotConversation'
			];

			const district = priority
					.map(type => projectLine?.associations?.find(a => a.morphable_type === type))
					.find(a => a?.morphable?.info?.address?.district?.name)
					?.morphable?.info?.address?.district?.name;
			return district
		},
		getProjectLineClient(projectLine){
			const priority = [
				'App\\Models\\Project',
				'App\\Models\\PreProject', 
				'App\\Models\\BotConversation'
			];
			const client = priority
					.map(type => projectLine?.associations?.find(a => a.morphable_type === type))
					.find(a => a?.morphable?.client?.profile)
					?.morphable?.client;
			return client.profile?.name + ' ' + client.profile?.lastname  + ' ' + client.profile?.second_lastname || ''
		},
		getNotificationImage(item){
			if(item.notifier_user?.profile?.avatar){
				return item.notifier_user?.profile?.avatar
			}
			if(this.isCompanyClient){
				return item?.company?.logo
			}
			return item?.itemable?.morphable?.client?.profile?.avatar
		},
		getClientName(item){
			const client = item.itemable?.client || item.itemable?.morphable?.client;
			
			if(!client){
				return ''
			}

			if(client?.profile){
				const profile = client.profile;
				return `${profile.name ?? ''} ${profile.lastname ?? ''} ${profile.second_lastname ?? ''}`.trim()
			}
			
			const profile = item.itemable?.morphable?.user?.user?.profile;
			const fallbackUser = item.itemable?.morphable?.user;

			const name = profile
				? `${profile.name ?? ''} ${profile.lastname ?? ''} ${profile.second_lastname ?? ''}`.trim()
				: fallbackUser
				? `${fallbackUser.name ?? ''} ${fallbackUser.lastname ?? ''} ${fallbackUser.second_lastname ?? ''}`.trim()
				: 'No identificado';

			return name || 'No identificado';
		},
		reloadNotifications(add = null){
			if(add){
				this.maxNotifications += add
			}
			else{
				this.maxNotifications = 10
			}
			this.$store.dispatch('notifications/getChatNotifications', {take: this.maxNotifications, types: [3]})
		},
		async viewItem(item, index){
			console.log(item)
			this.$router.replace({ path: this.$router.currentRoute.path, query: {} })
			if(item.item_type == 1){
				// Nueva conversación
				this.$router.push({ name: 'Conversation', params: { id: item.item_id } })
			}
			if(item.item_type == 2){
				// Agenda confirmada
				this.$router.push({ name: 'Conversation', params: { id: item.item_id } })
			}
			if(item.item_type == 3){
				// Chat mensaje desde preproject
				let query = {
					id: item.item_id
				}
				if(item.data?.project_line_id){
					query.project_line_id = item.data?.project_line_id;
				}
				// this.$router.push({ name: 'Chat', query })
				this.$router.replace({ name: 'Chat', query })
				// if(this.selectedCompany.capabilities.view_preprojects){
				// 	this.$router.push({ name: 'PreProject', params: { id: item.item_id } })
				// }
				// else{
				// 	this.$router.push({ name: 'ClientDetail', query: { p: item.item_id } })
				// }
				// this.$store.commit('preprojects/setOpenChatModal', true)	
			}
			if(item.item_type == 4){
				// Nueva observación en contrato
				if(item.data && item.data.panel_redirect_path){
					window.location.href = item.data.panel_redirect_path
				}
				else{
					this.$router.push({ name: 'ContractDetail', query: { id: item.item_id } })
				}
			}
			this.changeMenu(false)
			this.markNotificationAsRead(item.id, index)
		},
		async markNotificationAsRead(notification_id, index){
				this.loadingIndexes.push(index)
				const tasks = await markAsReaded({id: notification_id})
				if(tasks.code == 200){
					this.reloadNotifications()
				}
		},
		async markAllNotificationsAsRead(){
			const notification_ids = this.$store.state.notifications.chatNotifications.map((item) => {
				return item.id
			})
			if(notification_ids.length > 0){
				const tasks = await markAsReaded({ids: notification_ids})
				if(tasks.code == 200){
					this.reloadNotifications()
				}
			}
		},
		changeMenu(value){
			this.menuOpen = value
		}
	}
};
</script>

<style scoped>
	.container-notification-menu-header{
		background: white;
		margin-top: 10px;
		border-radius: 8px;
	}
	.notification-img{
		width: 40px;
		height: 40px;
		border-radius: 100%;
		object-fit: cover;
	}
	.notification-img.icon{
		background-color: #F0F2F8;
	}
	/deep/ .notification-description p{margin: 0;}
</style>
